import React from 'react';
import P, { InferProps } from 'prop-types';
import { SxStyle } from '../../../types';
import Grid from '@mui/material/Grid';
import ImageField from './image-field';
import TextInput from './text-field';
import SwitchField from './switch-field';

const styles: SxStyle = {
  containerInfo: {
    maxWidth: '600px',
  },
};
function PromoFieldImage({
  setChange,
  setValidation,
  fields,
  isReadOnly,
  path,
}: InferProps<typeof PromoFieldImage.propTypes>) {
  const [
    contentUrlField,
    ,
    /* promoType */ targetUrlField,
    promoOpenInAppField,
    widthField,
    heightField,
  ] = fields;

  return (
    <Grid container spacing={4} alignItems="center">
      <Grid item>
        <ImageField
          field={contentUrlField}
          widthField={widthField}
          heightField={heightField}
          setChange={setChange}
          key={contentUrlField.id}
          isReadOnly={isReadOnly}
          path={path}
          compact
        />
      </Grid>
      <Grid container item xs sx={styles.containerInfo} direction={'column'} spacing={2}>
        <Grid item>
          <TextInput
            field={targetUrlField}
            setChange={setChange}
            setValidation={setValidation}
            key={targetUrlField.id}
            isReadOnly={isReadOnly}
            fullWidth
          />
        </Grid>
        <Grid item>
          <SwitchField
            field={promoOpenInAppField}
            setChange={setChange}
            key={promoOpenInAppField.id}
            isReadOnly={isReadOnly}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

PromoFieldImage.propTypes = {
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  fields: P.any.isRequired,
  key: P.string,
  path: P.string.isRequired,
};

export default PromoFieldImage;
